import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const HeaderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  width: '100%',
  justifyContent: 'space-between',

  '.menuBtn': {
    width: '40px',
    height: '100%'
  },

  'div.applicationName': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    'h6':{
      fontWeight:'bold'
    },

    'img.logo': {
      display: 'none',
    },

    '.paddingLogo': {
      width: '0rem'
    }
  },

  'div.announcement': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.messageContent': {
      background: '#FFF',
      padding: '5px',
      boxShadow: '0px 0px 4px #fff',
      borderRadius: '5px',
      color: v.ezBackColor
    },

    '.messageContent>i': {
      color: v.ezRedColor
    },
  },

  'div.user': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',

    '.userFullName': {
      display: 'none'
    }
  },

  '@media only screen and (min-width: 600px)': {
    /* For Tablet: */
    '.menuBtn': {
      width: '40px',
      height: '100%',
    },

    'div.applicationName': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
  
      'h6':{
        fontWeight:'bold'
      },

      'img.logo': {
        display: 'none',
      },

      '.paddingLogo': {
        width: '0rem'
      }
    },

    'div.user': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',

      '.userFullName': {
        display: 'none'
      }
    },
  },

  '@media only screen and (min-width: 769px)': {
    /* For Desktop: */

    '.menuBtn': {
      display: 'none',
    },

    'div.applicationName': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
  
      'h6':{
        fontWeight:'bold'
      },

      'img.logo': {
        display: 'block',
      },

      '.paddingLogo': {
        width: '2rem'
      }
    },

    'div.user': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',

      '.userFullName': {
        display: 'block'
      }
    },
  }
})